module.exports = __webpack_public_path__ + "img/bg-behindrocks.46468ae2.svg";